export default "__VITE_ASSET__Bpk1nrHV__"